import {Company} from "./company";
import {Utils} from "../utils";
import {BaseModel} from "./base-model";
import {Role} from "./role";

export class Account extends BaseModel {

  protected self = Account;

  id: string;
  firstName: string;
  lastName: string;
  authProviderId: string;
  company: Company;
  roles: Role[];
  isAnonymous: boolean;

  constructor() {
    super();
    this.company = new Company();
  }

  // Use token from token fetcher if defined or from string
  _authToken: string;
  authTokenFetcher: Function;
  get authToken() {
    return this.authTokenFetcher ? this.authTokenFetcher() : this._authToken;
  }
  set authToken(authToken: string) {
    this._authToken = authToken;
  }

  get displayName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  public validate(): boolean {
    return !Utils.isEmpty(this.id) && this.company && !Utils.isEmpty(this.authToken);
  }

  public clear() {
    this.id = null;
    this.company = null;
    this.firstName = null;
    this.lastName = null;
    this.authProviderId = null;
    this.isAnonymous = null;
    this.authToken = null;
  }

}
